import React from "react";
import { cva } from "class-variance-authority";
import { cn } from "../lib/utils";

const toggleVariants = cva(
  "relative inline-flex shrink-0 items-center rounded-full border p-0.5 transition-all duration-300 ease-[cubic-bezier(0.25,1,0.3,1)] focus-visible:outline-none focus-visible:ring-4 disabled:cursor-not-allowed disabled:opacity-45",
  {
    variants: {
      checked: {
        true: "border-kin-green/20 bg-kin-green shadow-sm focus-visible:ring-kin-green/30",
        false:
          "border-kin-olive/20 bg-kin-olive/20 backdrop-blur-md focus-visible:ring-kin-olive/20",
      },
      size: {
        medium: "h-7 w-12",
        large: "h-8 w-14",
      },
    },
    defaultVariants: {
      checked: false,
      size: "medium",
    },
  },
);

const toggleThumbVariants = cva(
  "pointer-events-none block rounded-full bg-kin-white shadow-[0_2px_4px_rgba(0,0,0,0.15)] transition-transform duration-300 ease-[cubic-bezier(0.25,1,0.3,1)]",
  {
    variants: {
      checked: {
        true: "",
        false: "",
      },
      size: {
        medium: "h-6 w-6",
        large: "h-7 w-7",
      },
    },
    compoundVariants: [
      { checked: true, size: "medium", className: "translate-x-5 scale-[1.05]" },
      { checked: false, size: "medium", className: "translate-x-0" },
      { checked: true, size: "large", className: "translate-x-6 scale-[1.05]" },
      { checked: false, size: "large", className: "translate-x-0" },
    ],
    defaultVariants: {
      checked: false,
      size: "medium",
    },
  },
);

const Toggle = React.forwardRef(
  ({ className, checked = false, disabled, size = "medium", ...props }, ref) => (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      data-state={checked ? "checked" : "unchecked"}
      className={cn(toggleVariants({ checked, size, className }))}
      ref={ref}
      disabled={disabled}
      {...props}
    >
      <span aria-hidden="true" className={cn(toggleThumbVariants({ checked, size }))} />
    </button>
  ),
);

Toggle.displayName = "Toggle";

export { Toggle };
